module.exports = __webpack_public_path__ + "static/img/bannerBg1_en.74d0e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg1_en.png
// module id = 8Ox1
// module chunks = 1